import { Component, OnInit, Input } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { Subject } from 'rxjs';
import { serviceConstants } from 'src/app/constants/service.constants';
import { AttachmentClassificationComponent } from 'src/app/common/attachment-classification/attachment-classification.component';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { UserService } from '../../../../services/user.service';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { CommonService } from '../../../../services/common.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { EditOthersRenderer } from 'src/app/common/client-grid/edit-others-operations.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject, Document_Upload_File, SCREEN_CONTROL, SCREEN_RESPONSE, ScreenResponseModel } from 'src/app/models/common';
import { FileService } from 'src/app/services/file.service';
import { Attachments } from 'src/app/models/um/organization';
import * as _ from 'lodash';

@Component({
  selector: 'app-ist-amendments-view-modal',
  templateUrl: './ist-amendments-view-modal.component.html',
  styleUrls: ['./ist-amendments-view-modal.component.scss']
})
export class IstAmendmentsViewModalComponent implements OnInit {

  @Input() public Content: any;
  RequiredSettings: boolean = true;
  formData: FormData;
  columnDefs;
  gridApi: GridApi;
  rowData;
  context;
  gridOptions;
  frameworkComponents;
  loadGrid = false;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  ApplicationID: any;
  userType: string = "";
  amendment: any;
  appstatus: boolean;
  myDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  year = this.myDate.getFullYear();
  moth = this.myDate.getMonth() + 1;
  Day = this.myDate.getDate();
  operations: any[] = [];
  Attachments: any[] = [];
  staticformFields: any;
  IsFormToched: boolean = false;
  isDateModified: boolean = false;
  Full_Date: DateObject;
  submittedresponse: SCREEN_RESPONSE[] = [];
  Status: any;
  ID: any;
  Site_Visit_Date: any;
  visitUploadedFiles: any[] = [];
  screenName: string = "";
  genInfoFieldControls: any;
  Application_Type_ID: any;

  tooltipValue: any;
  selectedRow: any;
  TempOperations: { name: string; id: string; }[];
  tempoperations: any;
Currency_ID: string="";
  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private userService: UserService,
    public datepipe: DatePipe,
    public commonService: CommonService,
    public fileService: FileService,
  ) { }

  ngOnInit() {
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.GetScreenConfigControls('SCR-012');
    if (!this.ApplicationID) {
      this.GetIstGenInfoScreenConfigControls();
    }

    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.datashareService.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
     if (this.Currency_ID == null || this.Currency_ID == undefined || this.Currency_ID == "") {
      this.datashareService.Currency_ID.subscribe(x => {
        this.Currency_ID = x;
      });
    }
    this.rowData = [];
    this.appstatus = this.commonService.getIstStatus();

    if (this.Content.heading === 'Add') { //Add mode 
      this.Content.content.id = this.commonService.getUniqueId();
    }
    this.userType = this.userService.getUserType();
    this.TempOperations = [];

    if (this.Content.heading === 'Edit') { // Edit mode
      this.getRecordFprEdit();

    }
    else if (this.Content.heading === 'View') { //View mode 
      this.getRecordFprEdit();
    }
    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,
      IsScreenGrid: true,
      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }

    this.columnDefs = [
      {
        "headerName": "Attachment Classification",
        "field": "AttachmentClassification"
      },
      {
        "headerName": "File Name",
        "field": "FileName"
      },
      {
        "headerName": "Date",
        "field": "Date"
      },
      {
        headerName: "",
        field: "value",
        cellRenderer: "editOthersRenderer",
        colId: "params",
        width: 50,
        sortable: false,
        cellStyle: { "overflow": 'visible' }
      }

    ];
    this.context = { componentParent: this };
    this.frameworkComponents = {
      editOthersRenderer: EditOthersRenderer
    };

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }
  
  }

  getRecordFprEdit() {
    this.summaryService.getScreenDataForEdit("api/ISTAmendments/Edit?RecordID=" + this.Content.content.id).subscribe(result => {
      if (result) {
        this.setFormPermissions();
        this.BindDataToDynamicControls();
        this.BindDataToStaticControls(result);
      }
      this.rowData = result["Attachments"];
      this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);
      if (result["STATUS"] == '2') { // Edit mode
        this.Content.heading = "View";
      }
    });
  }


  SaveAmendments() {
    if (this.validateControls()) {
      if (this.staticformFields != null && this.staticformFields?.length > 0) {
        for (let i = 0; i < this.staticformFields?.length; i++) {
          switch (this.staticformFields[i].CONTROL) {
            case 6:
              let seletedItem = "";
              for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                if (this.staticformFields[i].SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = this.staticformFields[i].SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
                }
              }
              this.staticformFields[i].ANSWER = seletedItem;
              break;
            case 8:
              this.staticformFields[i].UploadedDocuments = [];
              if (this.staticformFields[i].UploadFiles) {
                for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                  if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                    this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                  }
                }
                this.staticformFields[i].ANSWER = null;
                this.staticformFields[i].ControlValue = null;
              }
              break;
            case 10:
              let SelectedValues = this.staticformFields[i].ControlValue;
              if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
                this.staticformFields[i].ANSWER = SelectedValues.join(",");
              }
              else {
                this.staticformFields[i].ANSWER = "";
              }
              this.staticformFields[i].SUBFIELDNAME = "";
              //this.staticformFields[i].ControlValue = null;
              break;
            case 5:
              let controlanswer = this.staticformFields[i].ControlValue;
              if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                this.staticformFields[i].ANSWER = formd;
              }
              else {
                this.staticformFields[i].ANSWER = controlanswer;
              }
              break;
            default:
              this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
              break;
          }
        }
        this.Attachments = [];
        this.rowData.forEach(element => {
          let attachData = new Attachments();
          attachData.FileID = element.FileID;
          attachData.FileName = element.FileName;
          attachData.AttachmentClassificationId = element.AttachmentClassificationId;
          attachData.AttachmentClassification = element.AttachmentClassification;
          attachData.IS_Dependent_Display_Clasification = element.IS_Dependent_Display_Clasification;
          attachData.IS_Dependent_Display_Upload = element.IS_Dependent_Display_Upload;

          this.Attachments.push(attachData);
        });

        let uploadData = new FormData();
        //uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
        let FinalControls = _.cloneDeep(this.staticformFields);
        FinalControls.forEach((item) => {
          switch (item.CONTROL) {
            case 10:
              item.ControlValue = null;
              break;
          }
        });
        uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
        uploadData.append("Status", "1");
        uploadData.append("Attachments", JSON.stringify(this.Attachments));
        uploadData.append("ID", this.Content.content.id);

        if (this.Content.heading == "Add") {
          if (!this.ApplicationID) {
            this.SaveIST_GI_APP().subscribe((res) => {
              if (res.Status === 0) {
                this.ApplicationID = res["TransactionID"];
                this.datashareService.setApplicationID(this.ApplicationID);
                uploadData.append("ApplicationID", this.ApplicationID);
                this.summaryService.FilesInsert("api/ISTAmendments/Insert", uploadData).subscribe(result => {
                  if (result.Status == 0) {
                    this.IsFormToched = false;
                    if (result.Status === 0) {
                      this.commonService.SuccessBanner(this.screenName + ' added successfully');
                      this.modalRef.close('yes');
                      this.commonService.refreshPage(this.ApplicationID);
                    }
                    else {
                      this.commonService.ValidationBanner(result.Message);
                    }

                  } else {
                    this.commonService.ValidationBanner(result.Message);
                  }
                });
              }
              else {
                this.commonService.ValidationBanner(res.Message);
              }
            })
          }
          else {
            uploadData.append("ApplicationID", this.ApplicationID);
            this.summaryService.FilesInsert("api/ISTAmendments/Insert", uploadData).subscribe(result => {
              if (result.Status == 0) {
                this.IsFormToched = false;
                if (result.Status === 0) {
                  this.commonService.SuccessBanner(this.screenName + ' added successfully');
                  this.modalRef.close('yes');
                }
                else {
                  this.commonService.ValidationBanner(result.Message);
                }

              } else {
                this.commonService.ValidationBanner(result.Message);
              }
            });
          }
        }
        else {
          let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);
          if (!inactiveValueControls || inactiveValueControls.length == 0) {
            uploadData.append("ApplicationID", this.ApplicationID);
            this.summaryService.FilesInsert("api/ISTAmendments/Update", uploadData).subscribe(result => {
              this.IsFormToched = false;
              if (result.Status === 0) {
                if (result.ErrorCode === "NOCHANGES") {
                  this.getRecordFprEdit();
                  this.commonService.ValidationBanner(result.Message);
                }
                else {
                  this.commonService.SuccessBanner(this.screenName + ' updated successfully');
                  this.modalRef.close('yes');
                }
              }
              else {
                this.getRecordFprEdit();
                this.commonService.ValidationBanner(result.Message);
              }
            });
          }
          else {
            let dataMsg = inactiveValueControls.join("</br>");
            this.commonService.ValidationBanner(dataMsg);
          }
        }
      }
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    this.staticformFields.forEach((item) => {
      if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
        switch (item.CONTROL) {
          case 1:
            if (!item.ControlValue) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 2:
          case 3:
            if (!item.ControlValue) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 4:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please select ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 5:
          case 11:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;

          case 10:

            if (!(item.ControlValue) || (item.ControlValue != null && item.ControlValue.length == 0 && item.Display_Field)) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }


            break;
          case 6:
            let seletedItem = "";
            for (let c = 0; c < item.SourceItems.length; c++) {
              if (item.SourceItems[c].Checked == true) {
                if (seletedItem == "")
                  seletedItem = item.SourceItems[c].value;
                else
                  seletedItem = seletedItem + "," + item.SourceItems[c].value;
              }
            }
            item.ControlValue = seletedItem;
            if (!item.ControlValue) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 7:
            if (!item.ControlValue) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 8:
            if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0 && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 9:
            break;
        }
      }
    });

    //Check atleast single field value exists
    if (isValid) {
      isValid = this.commonService.checkHasSingleControlValue(this.staticformFields);
      if (!isValid) {
        message += `Please enter atleast one field. <br/>`;
      }
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    return isValid;
  }

  SubmitRecord() {
    if (this.validateControls()) {
      if (this.staticformFields != null && this.staticformFields?.length > 0) {
        for (var i = 0; i < this.staticformFields?.length; i++) {
          switch (this.staticformFields[i].CONTROL) {
            case 6:
              let seletedItem = "";
              for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                if (this.staticformFields[i].SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = this.staticformFields[i].SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
                }
              }
              this.staticformFields[i].ANSWER = seletedItem;
              break;
            case 8:
              this.staticformFields[i].UploadedDocuments = [];
              if (this.staticformFields[i].UploadFiles) {
                for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                  if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                    this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                  }
                }
                this.staticformFields[i].ANSWER = null;
                this.staticformFields[i].ControlValue = null;
              }
              break;
            case 10:
              let SelectedValues = this.staticformFields[i].ControlValue;
              if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
                this.staticformFields[i].ANSWER = SelectedValues.join(",");
              }
              else {
                this.staticformFields[i].ANSWER = "";
              }
              this.staticformFields[i].SUBFIELDNAME = "";
              this.staticformFields[i].ControlValue = null;
              break;
            case 5:
              let controlanswer = this.staticformFields[i].ControlValue;
              if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                this.staticformFields[i].ANSWER = formd;
              }
              else {
                this.staticformFields[i].ANSWER = controlanswer;
              }
              break;
            default:
              this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
              break;
          }
        }

        this.rowData.forEach(element => {
          let attachData = new Attachments();
          attachData.FileID = element.FileID;
          attachData.FileName = element.FileName;
          attachData.AttachmentClassificationId = element.AttachmentClassificationId;
          attachData.AttachmentClassification = element.AttachmentClassification;
          attachData.IS_Dependent_Display_Clasification = element.IS_Dependent_Display_Clasification;
          attachData.IS_Dependent_Display_Upload = element.IS_Dependent_Display_Upload;
          this.Attachments.push(attachData);
        });

        let uploadData = new FormData();
        uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
        uploadData.append("ApplicationID", this.ApplicationID);
        uploadData.append("Status", "2");
        uploadData.append("Attachments", JSON.stringify(this.Attachments));
        uploadData.append("ID", this.Content.content.id);

        if (this.Content.heading == "Add") {
          this.summaryService.FilesInsert("api/ISTAmendments/Insert", uploadData).subscribe(result => {
            if (result.Status == 0) {
              this.IsFormToched = false;
              if (result.Status === 0) {
                this.commonService.SuccessBanner(this.screenName + ' submitted successfully');
                this.modalRef.close('yes');
              }
              else {
                this.commonService.ValidationBanner(result.Message);
              }

            } else {
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }
        else {
          this.summaryService.FilesInsert("api/ISTAmendments/Update", uploadData).subscribe(result => {
            this.IsFormToched = false;
            if (result.Status === 0) {
              if (result.ErrorCode === "NOCHANGES") {
                this.commonService.ValidationBanner(result.Message);
              }
              else {
                this.commonService.SuccessBanner(this.screenName + ' submitted successfully');
                this.modalRef.close('yes');
              }
            }
            else {
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }
      }
    }
  }


  onRowDoubleClicked(event) {
  }
  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  getAttachmentsData() {

    this.summaryService.getSummaryData("api/ISTFileAttachments/getScreenAttachments?TransactionID=" + 1).subscribe((result) => {
      this.rowData = result;
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 350);
    });


  }

  addNewAttachment() {
    let modalRef = this.modalService.open(AttachmentClassificationComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });


    modalRef.componentInstance.Content = {
      heading: 'Add',
      screencode: "SCR-012",
      content: { id: "", ModuleName: "IST", ScreenName: 'Amendments', filesList: this.rowData }
    }
    modalRef.result.then(result => {
      this.loadGrid = false;
      result.forEach((item: any) => {
        this.rowData.push(item);
      });
      this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);
    })

  }

  setOperations(RawData: any): any {

    RawData.forEach(element => {
      if (element.Status == "Add" && this.Content.heading == 'Edit') {
        this.TempOperations = [];
        this.TempOperations.push(
          {
            "name": "Delete",
            "id": "Delete"
          }
        );
        element["Operations"] = this.setDef(this.TempOperations);
      } else {
        let tempOperations;
        if (this.Content.heading == 'Edit') {
          tempOperations = [
            {
              "name": "Delete",
              "id": "Delete"
            },
            {
              "name": "Download",
              "id": "Download"
            }
          ];
        }

        if (this.Content.heading == 'View') {
          tempOperations = [
            {
              "name": "Download",
              "id": "Download"
            }
          ];
        }
        if (this.Content.heading == "Add") {

          tempOperations = [
            {
              "name": "Delete",
              "id": "Delete"
            }
          ];
        }

        if (this.commonService.isAllowedExtension(element.FileName) == true && this.Content.heading != "Add") {
          tempOperations.push(
            {
              "name": "Preview",
              "id": "ViewFileAttachment"
            }
          );
        }
        element["Operations"] = this.setDef(tempOperations);
      }

      if (element.FileID == null) {
        this.TempOperations = [];
        this.TempOperations.push(
          {
            "name": "Delete",
            "id": "Delete"
          }
        );
        element["Operations"] = this.setDef(this.TempOperations);
      }
    });
    return RawData;
  }

  setDef(parmoperations: any): any {

    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }


  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onOperationClick(opr) {
    opr.callback();
  }


  onGridReady(params) {
    this.gridApi = params.api;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }

  Download() {
    let fileID = this['self'].selectedRow['FileID'];
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  Delete() {
    let fileID = this['self'].selectedRow['FileID'];
    let fileName = this['self'].selectedRow['FileName'];
    this['self'].commonService.CheckIsFileIsRefereancedInReviw(fileID).subscribe((x) => {
      if (x["Status"] == 2 && x["Data"] == false) {
        this.commonService.ValidationBanner(x["Message"]);
      }
      else {
        let className = this['self'].selectedRow['AttachmentClassification'];
        let modalRef = this["self"].modalService.open(DeleteBoxComponent, { backdrop: false });
        if (fileName != null) {
          modalRef.componentInstance.Content = { heading: '', custommessage: 'Are you sure you want to delete the ' + "'" + fileName + "'" + '?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" };
        } else {
          modalRef.componentInstance.Content = { heading: '', custommessage: 'Are you sure you want to delete the ' + "'" + className + "'" + '?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" };

        }

        modalRef.result.then(result => {
          if (result == 'okclick') {
            let index = this['self'].rowData.findIndex(x => x.FileID == fileID);
            if (index != null) {
              this['self'].rowData.splice(index, 1);
              this['self'].loadGrid = false;
              setTimeout(() => {
                this['self'].loadGrid = true;
                document.body.click();
              }, 300);
            }
          }
        });
      }
    });
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }

  singleonChange($event, question) {
    this.IsFormToched = true;
    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question, "Y");
  }

  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })

    this.staticformFields.forEach((con) => {
      if (displayControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = false;
      }
      if (hideControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = true;
      }
      if (enableControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = false;
      }
      if (disbledControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = true;
      }
    });

  }

  // ApplyConditions($event, question, makeNull) {
  //   let value = $event.value;
  //   if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
  //     question.Control_Condtions = [];
  //   }
  //   let displayControlIDS = [];
  //   let hideControlIDS = [];
  //   let enableControlIDS = [];
  //   let disbledControlIDS = [];


  //   question.Control_Condtions.forEach((item) => {
  //     if (item.Mapped_Control_Value == value) {
  //       item.ConditionsList.forEach((otemCon) => {
  //         switch (otemCon.Mapped_Condtion) {
  //           case "1": //display
  //             if (displayControlIDS.length == 0) {
  //               displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //             }
  //             else {
  //               let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //               if (disCntrIds && disCntrIds.length > 0) {
  //                 disCntrIds.forEach((id) => {
  //                   if (!displayControlIDS.includes(id)) {
  //                     displayControlIDS.push(id);
  //                   }
  //                 })
  //               }
  //             }

  //             break;
  //           case "2": //enabled
  //             if (enableControlIDS.length == 0) {
  //               enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //             }
  //             else {
  //               let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //               if (enableCntrIds && enableCntrIds.length > 0) {
  //                 enableCntrIds.forEach((id) => {
  //                   if (!enableControlIDS.includes(id)) {
  //                     enableControlIDS.push(id);
  //                   }
  //                 })
  //               }
  //             }
  //             break;
  //           case "3": //hide
  //             if (hideControlIDS.length == 0) {
  //               hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //             }
  //             else {
  //               let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //               if (hideCntrIds && hideCntrIds.length > 0) {
  //                 hideCntrIds.forEach((id) => {
  //                   if (!hideControlIDS.includes(id)) {
  //                     hideControlIDS.push(id);
  //                   }
  //                 })
  //               }
  //             }

  //             break;

  //           case "4": //disabled
  //             if (disbledControlIDS.length == 0) {
  //               disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //             }
  //             else {
  //               let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //               if (disableCntrIds && disableCntrIds.length > 0) {
  //                 disableCntrIds.forEach((id) => {
  //                   if (!disbledControlIDS.includes(id)) {
  //                     disbledControlIDS.push(id);
  //                   }
  //                 })
  //               }
  //             }
  //             break;
  //         }

  //       });
  //     }
  //   })


  //   //default
  //   if (value != "") {
  //     this.staticformFields.forEach((con) => {
  //       if (displayControlIDS.indexOf(con.ID) > -1) {
  //         con.IS_Dependent_Display = true;
  //         if(makeNull == "Y")
  //         {
  //           con.ControlValue = "";
  //         }
  //         if (con.CONTROL == "10") {
  //           con.ControlValue = [];
  //         }
  //         if (con.CONTROL == "4")
  //           this.UpdateParentChildDetails(con);
  //       }
  //       if (hideControlIDS.indexOf(con.ID) > -1) {
  //         con.IS_Dependent_Display = false;
  //         if(makeNull == "Y")
  //         {
  //           con.ControlValue = "";
  //         }
  //         if (con.CONTROL == "10") {
  //           con.ControlValue = [];
  //         }
  //         if (con.CONTROL == "4")
  //           this.UpdateParentChildDetails(con);
  //       }
  //       if (enableControlIDS.indexOf(con.ID) > -1) {
  //         con.IS_Dependent_Enabled = true;
  //         if(makeNull == "Y")
  //         {
  //           con.ControlValue = "";
  //         }
  //         if (con.CONTROL == "10") {
  //           con.ControlValue = [];
  //         }
  //         if (con.CONTROL == "4")
  //           this.UpdateParentChildDetails(con);
  //       }
  //       if (disbledControlIDS.indexOf(con.ID) > -1) {
  //         con.IS_Dependent_Enabled = false;
  //         if(makeNull == "Y")
  //         {
  //           con.ControlValue = "";
  //         }
  //         if (con.CONTROL == "10") {
  //           con.ControlValue = [];
  //         }
  //         if (con.CONTROL == "4")
  //           this.UpdateParentChildDetails(con);
  //       }
  //     });
  //   }
  // }

  ApplyConditions($event, question, makeNull) {
    let value = $event.value;
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }

        });
      }
    })
    //default
    if (value != "") {
      this.staticformFields.forEach((con) => {

        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }

      });
    }
    else {
      this.UpdateParentChildDetails(question);
    }

    if (makeNull == "Y") {
      this.staticformFields.forEach((con) => {
        if (con.IS_Dependent_Display == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Display == true) {

        }
        if (con.IS_Dependent_Enabled == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Enabled == true) {

        }
      });
    }
  }


  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }

  uploadchange(event, ques: SCREEN_CONTROL): void {
    // let Flag = true;
    let Isexe = false;
    let Is5oMB = false;
    let IscrdDownload = false;
    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;

      if (file != null && (ext == 'exe')) {
        Isexe = true;
      }
      else if (file != null && (ext == 'crdownload')) {
        IscrdDownload = true;
      }
      else if (file != null && ((filesize > 52428800))) {
        Is5oMB = true;
      }
      else {
        this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = result.Data[0].FileID;
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = null;
          uploadFile.Status = "Add";
          uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
          let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
          if (hasValue.length > 0) {
            this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          }
          else if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          } else {
            //ques.UploadFiles = [];
            ques.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            })
            ques.UploadFiles.push(uploadFile);
          }
        });

      }
    }
    if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
    }
    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }
    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
    else if (IscrdDownload) {
      this.commonService.ValidationBanner("The system does not support .crdownload files. Please choose a different file format to save the details.")
    }
    else {

    }
  }

  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  DeleteUpload(file, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
        }
      });
    }
  }

  private setFormPermissions() {
    if (this.Content.heading == "view") {
      this.operations = [];
    }
    else {
      this.operations = [
        { name: 'SaveAmendments', type: 'submit', callback: this.SaveAmendments, self: this }
      ]
    }

  }

  BindDataToDynamicControls() {
    if (this.ApplicationID != null && this.ApplicationID != undefined && this.ApplicationID != "") {
      let sr = new ScreenResponseModel();
      sr.Id = "SCR-012";
      sr.RowId = this.Content.content.id;
      sr.AppId = this.ApplicationID;
      this.summaryService.getISTScreenResponse(sr).subscribe(summary => {
        this.submittedresponse = summary;
        if (this.submittedresponse != null && this.submittedresponse.length > 0) {
          for (let i = 0; i < this.staticformFields?.length; i++) {
            let response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);

            if (response != null && response.length > 0) {
              if (this.staticformFields[i].CONTROL == '6') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  let options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                  if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                    for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                      if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                        this.staticformFields[i].SourceItems[c].Checked = true;
                      }
                      else {
                        this.staticformFields[i].SourceItems[c].Checked = false;
                      }
                    }
                  }

                }
              }
              else if (this.staticformFields[i].CONTROL == '10') {
                this.staticformFields[i].NotimesChanged = 0;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = [];

                  let options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                  options1.forEach((item) => {
                    this.staticformFields[i].ControlValue.push(item);
                  });
                  this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                else {
                  this.staticformFields[i].ControlValue = [];
                }
              }
              else if (this.staticformFields[i].CONTROL == '5') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                  let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                  this.staticformFields[i].ControlValue = formd;

                  if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                    let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.staticformFields[i].ControlValue = formd;
                  }

                }

              }
              else {
                this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
              }
              this.staticformFields[i].UploadFiles = response[0].UploadFiles;
              if (this.staticformFields[i].CONTROL == '4') {
                this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
              }
            }

          }
        }


      });
    }
  }

  BindDataToStaticControls(MainObjData: any) {
    for (let i = 0; i < this.staticformFields?.length; i++) {
      let ControlValue = null;
      switch (this.staticformFields[i].FIELD_CODE) {
        case "APPLICATION_ID":
          this.staticformFields[i].ControlValue = MainObjData?.APPLICATION_ID;
          break;
        case "TYPE":
          this.staticformFields[i].Display_Field = true;

          this.staticformFields[i].ControlValue = MainObjData?.Type;
          break;
        case "TITLE":
          this.staticformFields[i].Display_Field = true;

          this.staticformFields[i].ControlValue = MainObjData?.Title;
          break;
        case "NOTES":
          this.staticformFields[i].Display_Field = true;

          this.staticformFields[i].ControlValue = MainObjData?.Notes;
          break;
        case "Attachments":
          this.staticformFields[i].Display_Field = false;

          this.staticformFields[i].ControlValue = MainObjData?.Attachments;
          break;
        case "Amendment_AC":
          this.staticformFields[i].Display_Field = false;
          break;
        case "Amendment_CF":
          this.staticformFields[i].Display_Field = false;
          break;
      }

      if (this.staticformFields[i].CONTROL == '4') {
        this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
      }
    }

  }

  ViewFileAttachment() {
    let fileID = this['self'].selectedRow['FileID'];
    let fileName = this['self'].selectedRow['FileName'];
    this['self'].commonService.previewFile(fileID, fileName, "med");
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.Content.content.id, (ScreenData) => {
      this.screenName = ScreenData.NAME;
      this.staticformFields = ScreenData["SCREEN_CONTROL"];
      this.staticformFields.forEach((item) => {
        item.Display_Field = true;
      })
      this.getRecordFprEdit();
    });
  }

  GetIstGenInfoScreenConfigControls() {
    this.commonService.GetScreenConfigControls('SCR-001', '', '', (ScreenData) => {
      this.genInfoFieldControls = ScreenData["SCREEN_CONTROL"];
    });
  }

  SaveIST_GI_APP() {
    let uploadData = new FormData();
    uploadData.append("ScreenControlsData", JSON.stringify(this.genInfoFieldControls));
    uploadData.append("Appid", '');
    uploadData.append("Application_Type_ID", this.Application_Type_ID);
    uploadData.append("Currency_ID", this.Currency_ID);

    return this.summaryService.SaveIstGeneralInfo("api/ISTGeneralInfo/Insert", uploadData);
  }

  isAllowedExtensionFile(Filename) {
    return this.commonService.isAllowedExtension(Filename);
  }

  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl = question.ControlValue;
      if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControl.indexOf(item.value) > -1;
        })
        let labellist = [];
        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }

    }, 200);

  }
}
